
export const PublicReturnAddress = new TypedDocumentString(`
    query PublicReturnAddress($sellerId: ObjectId!) {
  publicReturnAddress(sellerId: $sellerId) {
    ...SellerInfoAddress
    __typename
  }
}
    fragment SellerInfoAddress on SellerInfoAddress {
  fullname {
    value
    __typename
  }
  street {
    value
    __typename
  }
  apartment {
    value
    __typename
  }
  city {
    value
    __typename
  }
  state {
    value
    __typename
  }
  tel {
    value
    __typename
  }
  postCode {
    value
    __typename
  }
  country {
    ...BuyerAddressCountry
    __typename
  }
  deliveryInstruction {
    value
    __typename
  }
  __typename
}
fragment BuyerAddressCountry on BuyerAddressCountry {
  iso2
  __typename
}`, {"hash":"964ca16c92e9a7ede5d636458e3f1acae6ba07d38450591096f1a026dd4de4b9"});